import { render, staticRenderFns } from "./Nicknames.vue?vue&type=template&id=245f3fa3&scoped=true"
import script from "./Nicknames.js?vue&type=script&lang=js&external"
export * from "./Nicknames.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245f3fa3",
  null
  
)

export default component.exports